'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { ASSETS_GRID_SCROLLER_ID } from '@/lib/config'
import { useFiltersStore } from '@/lib/store/filters-store'
import { useShallow } from 'zustand/react/shallow'

/**
 * This component is responsible for scrolling to the top of the asset grid when navigating to a new page.
 * Also will scroll to the top when a filter is changed.
 */
export default function ScrollTopOnNavigate() {
  const pathname = usePathname()
  const filters = useFiltersStore(useShallow((state) => state.filters))
  const keywords = useFiltersStore(useShallow((state) => state.usedKeywords))

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const element = document.getElementById(ASSETS_GRID_SCROLLER_ID)
      if (element) {
        console.debug('Scrolling to top of element:', ASSETS_GRID_SCROLLER_ID, {
          pathname,
          filters,
          keywords,
        })
        element.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    }
  }, [pathname, filters, keywords])

  return null
}
